import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {Alert, Stack} from "@mui/material";
import {countryArray, getCountryName, getRlPilot} from "../../util/standards-util";
import Grid2 from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import {ArrowBack} from "@mui/icons-material";
import {findFlagUrlByIso2Code} from 'country-flags-svg';


const PilotInfo = ({entry, event, onClose = ()=>{}}) => {

    const registration = entry.registration
    const details = entry.details
    const pilot = entry.pilot

    const textFieldVariant = 'standard'

    const [rlData, setRlData] = React.useState()

    const handleSubmit = () => {

    }

    useEffect(() => {
        if (entry.details.igcRankingId && !isNaN(entry.details.igcRankingId)) {
            getRlPilot(entry.details.igcRankingId,(data)=>{
                if (data.status==='OK') {
                    const nationalityLabel = getCountryName(data.data.nationality)
                    data.data.nationalityLabel = nationalityLabel ? nationalityLabel : data.data.nationality
                    setRlData(data.data)
                }
            })
        }
    }, []);

    return (
        <>
            <Box sx={{
                display:'flex',
                alignItems:'center',
                //justifyContent:'space-between',
                mt:'1em',
                columnGap:'2em',
                mb:'2em',
            }}>
                <IconButton onClick={onClose}><ArrowBack/></IconButton>
                <Typography variant={'h5'} flexGrow={1} textAlign={'left'} component={'div'} sx={{display:'flex',alignItems:'center'}}>
                    {entry.pilot.firstname} {entry.pilot.lastname}
                    <img src={findFlagUrlByIso2Code(entry.pilot.nationality)} style={{height:'1em',marginLeft:'1em'}}/>
                </Typography>
            </Box>
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Grid2 spacing={4} container sx={{alignItems:'stretch'}}>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Pilot info
                                </Typography>
                                <TextField variant={textFieldVariant} id="pilot" name="pilot" label="Pilot"  value={`${pilot.firstname} ${pilot.lastname}`}/>
                                <TextField variant={textFieldVariant} id="email" name="email" label="Email"  value={details.email}/>
                                <TextField variant={textFieldVariant} id="nationality" name="nationality" label="Nationality"  value={countryArray.find( c => c.key===pilot.nationality).label}/>
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Sporting info
                                </Typography>
                                <TextField variant={textFieldVariant} id="igcRankingId" name="igcRankingId" label="IGC Ranking List ID"  value={details.igcRankingId} />
                                {rlData &&
                                    <Box sx={{textAlign:'left'}}>
                                        <Typography variant={'body1'} sx={{fontWeight:700}}>IGC Ranking List Data</Typography>
                                        <Box mb={2}>{rlData.firstname} {rlData.surname} {rlData.nationalityLabel ? ' ('+rlData.nationalityLabel+')' : ''}</Box>
                                        {rlData.surname !==pilot.lastname && rlData.firstname !==pilot.firstname &&
                                            <Alert severity={'error'}>Please check IGC RL ID for match to pilot</Alert>
                                        }
                                        {rlData.surname ===pilot.lastname && rlData.firstname ===pilot.firstname &&
                                            <Alert severity={'success'}>IGC RL data matches pilot</Alert>
                                        }
                                        {(rlData.surname !==pilot.lastname || rlData.firstname !==pilot.firstname) &&
                                            !(rlData.surname !==pilot.lastname && rlData.firstname !==pilot.firstname) &&
                                            <Alert severity={'warning'}>Please check IGC RL data matches pilot information</Alert>
                                        }
                                    </Box>
                                }
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Sailplane info
                                </Typography>
                                <TextField variant={textFieldVariant} id="gliderDescription" name="gliderDescription" label="Sailplane type" value={details.gliderDescription} />
                                <TextField variant={textFieldVariant} id="compId" name="compId" label="Sailplane competition ID"  value={details.compId} />
                                <TextField variant={textFieldVariant} id="sailplaneRegistration" name="sailplaneRegistration" label="Sailplane registration"  value={details.sailplaneRegistration} />
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Logger & tracking info
                                </Typography>

                                <TextField variant={textFieldVariant} id="primaryLoggerSerial" name="primaryLoggerSerial" label="Primary logger serial number"  value={details.primaryLoggerSerial} />
                                <TextField variant={textFieldVariant} id="secondaryLoggerSerial" name="secondaryLoggerSerial" label="Secondary logger serial number"   value={details.secondaryLoggerSerial} />
                                <TextField variant={textFieldVariant} id="flarmId" name="flarmId" label="Flarm ID"  value={details.flarmId} />
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Contact details
                                </Typography>

                                <TextField variant={textFieldVariant} id="phone" name="phone" label="Mobile number"  value={details.phone} />

                                <Box sx={{display:'flex',flexDirection:'column',alignItems:'stretch',rowGap:'.5em'}}>
                                    <TextField variant={textFieldVariant} id="address1" name="address1" label="Street address" value={details.address1} />
                                    <TextField variant={textFieldVariant} id="address2" name="address2" label="Street address 2" value={details.address2} />
                                    <TextField variant={textFieldVariant} id="city" name="city" label="City" value={details.city} />
                                    <TextField variant={textFieldVariant} id="zipcode" name="zipcode" label="Postal code" value={details.zipcode} />
                                    <TextField variant={textFieldVariant} id="region" name="region" label="State / Province / Region" value={details.region} />
                                    <TextField variant={textFieldVariant} id="country" name="country" label="Country" value={countryArray.find( c => c.key===details.country).label}/>
                                </Box>
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Contact info during competition
                                </Typography>

                                <TextField variant={textFieldVariant} id="competitionPhone" name="competitionPhone" label="Mobile number during competition (if different)" value={details.competitionPhone} />
                                <TextField variant={textFieldVariant} id="crewName" name="crewName" label="Crew name"  value={details.crewName} />
                                <TextField variant={textFieldVariant} id="crewPhone" name="crewPhone" label="Crew mobile number"  value={details.crewPhone} />
                                <TextField variant={textFieldVariant} id="crewCompetitionPhone" name="crewCompetitionPhone" label="Crew secondary mobile number"  value={details.crewCompetitionPhone} />
                                <TextField variant={textFieldVariant} id="crewEmail" name="crewEmail" label="Crew email"  value={details.crewEmail} />
                            </Stack>
                        </Paper>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
};

export default PilotInfo;